import { Context } from '@/context';
import { useContext } from 'react';

const useFantasySelected = () => {
    const { state } = useContext(Context);

    return {
        fantasy: state?.preferences?.fantasy,
        fantasyMode: state?.preferences?.mode,
        confirmedFantasy: state?.preferences?.confirmedFantasy,
        confirmedFantasyMode: state?.preferences?.confirmedFantasyMode,
    };
};

export default useFantasySelected;
